type optstring = string | undefined;

export class FirebaseConfiguration {
  private static validateStr(val: optstring): string {
    if (val === undefined) {
      throw new Error("Invalid config");
    }

    return val;
  }

  public apiKey: string;
  public authDomain: string;
  public databaseURL: string;
  public projectId: string;
  public storageBucket: string;
  public messagingSenderId: string;

  constructor(
    apiKey: optstring,
    authDomain: optstring,
    databaseURL: optstring,
    projectId: optstring,
    storageBucket: optstring,
    messagingSenderId: optstring
  ) {
    this.apiKey = FirebaseConfiguration.validateStr(apiKey);
    this.authDomain = FirebaseConfiguration.validateStr(authDomain);
    this.databaseURL = FirebaseConfiguration.validateStr(databaseURL);
    this.projectId = FirebaseConfiguration.validateStr(projectId);
    this.storageBucket = FirebaseConfiguration.validateStr(storageBucket);
    this.messagingSenderId = FirebaseConfiguration.validateStr(
      messagingSenderId
    );
  }
}

export default new FirebaseConfiguration(
  process.env.REACT_APP_API_KEY,
  process.env.REACT_APP_AUTH_DOMAIN,
  process.env.REACT_APP_DATABASE_URL,
  process.env.REACT_APP_PROJECT_ID,
  process.env.REACT_APP_STORAGE_BUCKET,
  process.env.REACT_APP_MESSAGING_SENDER_ID
);



// WEBPACK FOOTER //
// ./src/Firebase/config.ts